export default __webpack_public_path__ + "static/media/01.42e59412.jpg";